import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'rcp-dashboard-tile',
  template: `
    <div
      class="rcp-dashboard-tile"
      [class.active]="active()"
      [class.disabled]="disabled()"
      [class.clickable]="clickable()"
    >
      <div class="dashboard-tile-header">
        @if (icon()) {
          <span class="dashboard-tile-icon" [class]="iconColor()">
            <fa-icon [icon]="icon()" />
          </span>
        }
        @if (count() !== undefined) {
          <span class="dashboard-tile-count">{{ count() }}</span>
        }
        <ng-content />
      </div>
      <div class="dashboard-tile-main">
        <div class="dashboard-tile-label">{{ label() }}</div>
        @if (description()) {
          <div class="dashboard-tile-description">{{ description() }}</div>
        }
      </div>
    </div>
  `,
  styleUrls: ['./dashboard-tile.component.scss'],
  imports: [FaIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DashboardTileComponent {
  icon = input<IconProp | undefined>();
  iconColor = input<'primary' | 'secondary' | 'positive'>('secondary');
  count = input<string | number | undefined>();
  label = input<string | undefined>();
  description = input<string | undefined>();
  active = input<boolean>(false);
  disabled = input<boolean>(false);
  clickable = input<boolean>(true);
}
